import { createFileRoute, Link } from '@tanstack/react-router';
import { useProductions } from '@/data/productions';
import { Button } from '@/components/ui/Button';
import { Empty } from '@/components/ui/Empty';

export const Route = createFileRoute('/admin/productions/')({
  component: ProductionsIndex,
});

function ProductionsIndex() {
  const productions = useProductions();

  return (
    <div className="space-y-8">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="tracking-[var(--tracking-wide)] text-[var(--color-ink-muted)] text-[var(--text-sm)] uppercase">
            Recital + competition
          </p>
          <h1 className="mt-2">Productions</h1>
        </div>
        <Link to="/admin/productions/new">
          <Button>New production</Button>
        </Link>
      </div>

      {productions.isLoading && <p aria-live="polite">Loading…</p>}

      {productions.data?.length === 0 && (
        <Empty
          title="No productions yet"
          description="Create a production to start building the recital lineup."
          action={
            <Link to="/admin/productions/new">
              <Button>Create production</Button>
            </Link>
          }
        />
      )}

      {productions.data && productions.data.length > 0 && (
        <ul className="grid gap-3">
          {productions.data.map((p) => (
            <li key={p.id} className="surface-elevated">
              <Link
                to="/admin/productions/$id"
                params={{ id: p.id }}
                className="block p-5 hover:bg-[var(--color-surface-sunken)]"
              >
                <div className="flex items-baseline justify-between gap-3">
                  <h2 className="font-[var(--font-display)] text-[var(--text-xl)]">{p.name}</h2>
                  <p className="text-[var(--color-ink-muted)] text-[var(--text-sm)]">{p.season}</p>
                </div>
                {p.venue_name && (
                  <p className="mt-1 text-[var(--color-ink-muted)] text-[var(--text-sm)]">
                    at {p.venue_name}
                  </p>
                )}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
